import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useListPage from 'hooks/useListPage';
const StaffvwListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/staffvw/view/${data.id}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('staffvw/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/staff/edit/${data.id}`) },
			visible: () => auth.canView('staff/edit')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function EmailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.email}`}>{ data.email }</a>
			);
		}
	}
	function PhonenumberTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`tel:${data.phonenumber}`}>{ data.phonenumber }</a>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="StaffvwListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Staff "   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <Link to={`/staff/add`}>
                        <Button label="Add New Staff" icon="pi pi-arrow-left" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    value={records} 
                                    dataKey="id" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column  field="id" header="Id"  sortable={true} ></Column>
                                    <Column  field="employeeid" header="Employeeid"  sortable={true} ></Column>
                                    <Column  field="fullname" header="Fullname"  sortable={true} ></Column>
                                    <Column  field="email" header="Email" body={EmailTemplate} sortable={true} ></Column>
                                    <Column  field="phonenumber" header="Phonenumber" body={PhonenumberTemplate} sortable={true} ></Column>
                                    <Column  field="address" header="Address"   ></Column>
                                    <Column  field="role" header="Role"  sortable={true} ></Column>
                                    <Column  field="department" header="Department"   ></Column>
                                    <Column  field="hiredate" header="Hiredate"  sortable={true} ></Column>
                                    <Column  field="status" header="Status"   ></Column>
                                    <Column  field="availabilitystatus" header="Availabilitystatus"   ></Column>
                                    <Column  field="currentlatitude" header="Currentlatitude"   ></Column>
                                    <Column  field="currentlongitude" header="Currentlongitude"   ></Column>
                                    <Column  field="vehicletype" header="Vehicletype"   ></Column>
                                    <Column  field="vehiclenumber" header="Vehiclenumber"   ></Column>
                                    <Column  field="salary" header="Salary"   ></Column>
                                    <Column  field="commissionrate" header="Commissionrate"   ></Column>
                                    <Column  field="createdat" header="Createdat"   ></Column>
                                    <Column  field="updatedat" header="Updatedat"   ></Column>
                                    <Column  field="date_created" header="Date Created"   ></Column>
                                    <Column  field="date_updated" header="Date Updated"   ></Column>
                                    <Column  field="userid" header="Userid"   ></Column>
                                    <Column  field="partnerid" header="Partnerid"   ></Column>
                                    <Column  field="puserid" header="Puserid"   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
StaffvwListPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'staffvw',
	apiPath: 'staffvw/index',
	routeName: 'staffvwlist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default StaffvwListPage;
